import { render, staticRenderFns } from "./MzShopifyRecommendations.vue?vue&type=template&id=3f11417e&"
import script from "./MzShopifyRecommendations.vue?vue&type=script&lang=js&"
export * from "./MzShopifyRecommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports